import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink, } from "@apollo/client";
import { generateClient } from "@aws-amplify/api";
import { fetchAuthSession } from "@aws-amplify/auth";
import { createAuthLink, AUTH_TYPE } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";

const url = process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT;
const region = process.env.REACT_APP_REGION;

let lastApiCallTime = Date.now();

export const resetIdleTimer = () => {
  lastApiCallTime = Date.now();
  console.log("Apollo idle timer reset");
};

const getValidIdToken = async () => {
  const currentTime = Date.now();
  const idleTimeLimit = 15 * 60 * 1000; // 15 minutes

  if (currentTime - lastApiCallTime > idleTimeLimit) {

    // alert("You have been idle for 15 minutes. Please log in again.");
    sessionStorage.clear();
    window.location.href = "/"; // force logout
    return null;
  }

  lastApiCallTime = currentTime;

  const session = await fetchAuthSession({ forceRefresh: false });

  // Check if token is about to expire
  const expiresAt = session.tokens?.idToken?.payload?.exp * 1000;
  if (expiresAt - Date.now() < 5 * 60 * 1000) {
    const refreshedSession = await fetchAuthSession({ forceRefresh: true }); // return refreshed token
    return refreshedSession.tokens?.idToken?.toString();
  }

  return session.tokens?.idToken?.toString();
};


const auth = {
  type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
  jwtToken: getValidIdToken,
};


// const auth = {
//   type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
//   jwtToken: async () => {
//   // (
//   //   await fetchAuthSession({ forceRefresh: true })
//   // ).tokens?.idToken?.toString(),
// };

const link = ApolloLink.from([
  // @ts-ignore
  createAuthLink({ url, region, auth }),
  // @ts-ignore
  createHttpLink({ uri: url }),
]);

const httpLink = createHttpLink({ uri: url });

const _link = ApolloLink.from([
  createAuthLink({ url, region, auth }),
  createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
]);

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
  mutate: {
    errorPolicy: "all",
  },
};

export const subClient = generateClient();

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
});

const subscriptionClient = new ApolloClient({
  link: _link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
});

export async function getQuery(query) {
  const queryName = query.definitions[0].name?.value || "Unnamed Query";
  try {
    const data = await client.query({ query: query });

    console.groupCollapsed(`🔍 [Query] ${queryName}`);
    console.log("Data:", data);
    console.groupEnd();

    return data;
  } catch (e) {
    console.error("ERROR AT QUERY " + query + e);
  }
}

export async function fetchQuery(query, data) {
  const queryName = query.definitions[0].name?.value || "Unnamed Fetch";
  try {
    const response = await client.query({
      variables: { ...data },
      query: query,
    });

    console.groupCollapsed(`🔍 [FetchQuery] ${queryName}`);
    console.log("Variables:", data);
    console.log("Response:", response);
    console.groupEnd();

    return response;
  } catch (e) {
    console.error("ERROR AT QUERY " + e);
  }
}

export async function postMutation(query, data) {
  const mutationName = query.definitions[0].name?.value || "Unnamed Mutation";
  try {
    const response = await client.mutate({
      variables: { data },
      mutation: query,
    });

    console.groupCollapsed(`🚀 [Mutation] ${mutationName}`);
    console.log("Variables:", data);
    console.log("Response:", response);
    console.groupEnd();

    return response;
  } catch (e) {
    console.error("ERROR AT MUTATION " + e);
  }
}

export async function getQueryWithParams(query, data, spread = false) {
  const queryName = query.definitions[0].name?.value || "Unnamed Params Query";
  try {
    // console.log(data, { ...data });
    const response = await client.query({
      variables: spread ? { ...data } : { data },
      query: query,
    });

    console.groupCollapsed(`🔍 [QueryParams] ${queryName}`);
    console.log("Variables:", data);
    console.log("Response:", response);
    console.groupEnd();

    return response;
  } catch (e) {
    console.error("ERROR AT QUERY " + e);
    return undefined;
  }
}

export default client;

export async function subscription(query, variables = {}, next, error) {
  try {
    const response = subscriptionClient
      .subscribe({ query: query, variables })
      .subscribe({
        next,
        error,
        complete() {
          // console.info("subs. DONE");
        },
      });

    return response;
    // return setTimeout(response.unsubscribe(),1000);
  } catch (e) {
    console.error("Error in subscription", e);
  }
}

// ****************
